module.exports = __webpack_public_path__ + "img/pk_curve.ff73e96e.png";